import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../../api/api";
import { Chart, ArcElement, Legend, Tooltip } from "chart.js";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Grid, GridReadyEvent } from "ag-grid-community";
import "ag-grid-enterprise";
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import { MenuModule } from "@ag-grid-enterprise/menu";
import "react-tabs/style/react-tabs.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
import { formateAsPercent, formateDataCurr, formateDataPrec } from "../../utils/types";

Chart.register(ArcElement, Legend, Tooltip);

interface SAProps {
  title: string;
}
export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}
function ParticipantBalances({ title }: any) {
  const [participantStatement, setParticipantStatement] = useState<any>(null);
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);

  const selectedClient: any = Cookies.get("client");
  const onGridReady = useCallback((params: GridReadyEvent) => {
    FetchDataTypes(
      "ParticipantBalances",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response.json())
      .then((response) => {
        setParticipantStatement(response);
      });
  }, []);

  const ColumnDefs = [
    {
        field: "participantNumber",
        headerName: "Number",
        width: 140,
        cellClass: "cell-wrap-text",
        //cellRenderer: formateDataCurr,
        //headerClass: "headerTextAlign",
      },
    {
      field: "participantName",
      headerName: "Name",
      width: 150,
      resizable: true,
      cellClass: "cell-wrap-text",
      flex: 1,
    },
    
    {
      field: "participantBalance",
      headerName: "Balance",
      cellRenderer: formateDataCurr,
      width: 150,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
        field: "pct",
        headerName: "Pct",
        cellRenderer: formateDataPrec,
        width: 150,
        cellClass: "cell-wrap-text textAlign",
        headerClass: "headerTextAlign",
      },
  ];

  const handleExportExcel = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colId === "dateColumn") {
          // Format date as desired
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (params.column.colId === "pct") {
          // Format percentage as desired
          return params.value
            ? `${params.value}%`
            : "";
        }
        if (typeof params.value === "string") {
          // Apply currency symbol to string values
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          // Format numbers as currency with the currency symbol
          return `$${params.value.toFixed(2)}`;
        }
        return params.value !== null ? `$${params.value}` : "--";
      },
    };

    dataGridRefMain.current?.api.exportDataAsExcel(params);
  }, []);

  const handleExportPdf = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(8);

    const title = "Participant Balances";
    const headers = [["Number", "Name", "Balance", "Pct"]];

    const data = participantStatement.map((e: any) => [
      e.participantNumber,
      e.participantName,
      e.participantBalance !== null ? `$${e.participantBalance}` : "--",
      e.pct !== null ? `${e.pct}%` : "--",
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("ParticipantBalances.pdf");
  };
  return (
    <div className="card w-100">
      <div className="col-sm-3 w-100 d-flex pt-3 justify-content-between tableFilters px-4">
        <h5 className="card-title">{title ? title : "Participant Balances"}</h5>
        <div className="col-sm-2 my-3 text-end">
          <i
            className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
            style={{ fontSize: "16px" }}
            onClick={handleExportExcel}
          ></i>
          <i
            className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
            onClick={() => handleExportPdf()}
            style={{ fontSize: "16px" }}
          ></i>
        </div>
      </div>
      <div className="card-body">
        <div className="chart chart-xs">
          <div className="chartjs-size-monitor">
            <div className="chartjs-size-monitor-shrink">
              <div
                className="ag-theme-alpine"
                style={{
                  height: "560px",
                  width: "100%",
                }}
              >
                <AgGridReact
                  ref={dataGridRefMain}
                  rowData={participantStatement}
                  columnDefs={ColumnDefs}
                  onGridReady={onGridReady}
                  pagination={true}
                  paginationPageSize={20}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { ParticipantBalances };
